import { useEffect, useState } from "react";
import { Row, Col, Typography, Card } from "antd";
import Chart from "react-apexcharts";
import { PieChartOutlined } from "@ant-design/icons";
import "../../../assets/css/apex-overwrides.css";
import { useTranslation } from "react-i18next";

const { Title, Text } = Typography;

const CopilotsUsageCard = ({ analytics }) => {
  const { t } = useTranslation();

  const [options] = useState({
    chart: {
      height: 350,
      type: "treemap",
      fontFamily: "Inter, sans-serif",
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      treemap: {
        colorScale: {
          ranges: [
            {
              from: -6,
              to: 0,
              color: "#ff4d4f",
            },
            {
              from: 0.001,
              to: 6,
              color: "#1890ff",
            },
            {
              from: 6.001,
              to: 20,
              color: "#52c41a",
            },
            {
              from: 20.001,
              to: 100,
              color: "#722ed1",
            },
          ],
        },
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "12px",
        fontWeight: 500,
        colors: ["#fff"],
      },
    },
    noData: {
      text: "Loading...",
    },
  });
  const [series, setSeries] = useState([]);
  const [noData, setNoData] = useState(false);

  useEffect(() => {
    if (analytics?.copilots && analytics?.copilots?.length > 0) {
      // analytics.copilots is an array of arrays, where each inner array is a copilot and their usage. Ex: [["Copilot 1", 10], ["Copilot 2", 20]]
      const copilotsData = analytics?.copilots?.map((copilot) => ({
        x: copilot[0],
        y: copilot[1],
      }));

      setSeries([
        {
          name: "Copilots",
          data: copilotsData,
        },
      ]);
    } else {
      setNoData(true);
    }
  }, [analytics]);

  return (
    <Card
      style={{
        background: "white",
        border: "1px solid #e8e8e8",
        borderRadius: "16px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
        height: "100%",
      }}
      bodyStyle={{ padding: "24px" }}
    >
      {/* Header */}
      <div style={{ marginBottom: "20px" }}>
        <div
          style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}
        >
          <PieChartOutlined
            style={{
              fontSize: "20px",
              marginRight: "12px",
              color: "#1890ff",
            }}
          />
          <Title
            level={4}
            style={{
              color: "#262626",
              margin: 0,
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            {t("dashboard.copilotsUsage")}
          </Title>
        </div>
        <Text
          style={{
            color: "#8c8c8c",
            fontSize: "14px",
            fontWeight: "400",
          }}
        >
          {t("dashboard.copilotsUsageDesc")}
        </Text>
      </div>

      {/* Chart */}
      <div
        style={{
          background: "#fafafa",
          borderRadius: "12px",
          padding: "16px",
          border: "1px solid #f0f0f0",
        }}
      >
        {!noData ? (
          <Chart
            options={options}
            series={series}
            type="treemap"
            height={350}
            legend="legend"
          />
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "350px",
              background: "white",
              borderRadius: "8px",
              border: "2px dashed #e8e8e8",
            }}
          >
            <PieChartOutlined
              style={{
                fontSize: "48px",
                color: "#d9d9d9",
                marginBottom: "16px",
              }}
            />
            <Title
              level={4}
              style={{
                color: "#8c8c8c",
                margin: "0 0 8px 0",
                fontSize: "18px",
                fontWeight: "500",
              }}
            >
              {t("dashboard.noData")}
            </Title>
            <Text
              style={{
                color: "#bfbfbf",
                fontSize: "14px",
                textAlign: "center",
              }}
            >
              {t("dashboard.noDataDesc")}
            </Text>
          </div>
        )}
      </div>
    </Card>
  );
};

export default CopilotsUsageCard;
